"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getReactRoot;
var GF_REACT_ROOT = '_gf_react_root';

function getReactRoot() {
  if (typeof window !== 'undefined') {
    return window[GF_REACT_ROOT];
  }

  return null;
}